angular.module('zc.core')
  .controller('TosHeaderController', TosHeaderController);

TosHeaderController.$inject = [
  '$location',
  '$rootScope',
  '$translate',
  'Devise',
  'languages',
];
function TosHeaderController(
  $location,
  $rootScope,
  $translate,
  Devise,
  languages,
) {
  const vm = this;

  vm.$onInit = () => {
    vm.selectedLanguage = null;

    if(languages) {
      vm.languages = languages;
    } else {
      throw new Error('Please specify available languages for TosHeaderController in router');
    }

    const FALLBACK_LANGUAGE = vm.languages[0];

    vm.selectLanguage = selectedLanguage => {
      vm.selectedLanguage = selectedLanguage;
      $rootScope.$emit('languageSelected', selectedLanguage);
    };

    const selectDefaultLanguage = () => {
      Devise.getCurrentUserLanguage().then(currentUserLanguage => {
        const id = $location.search().lang || currentUserLanguage || $translate.preferredLanguage();
        const defaultLanguage = _.find(vm.languages, {
          id,
        }) || FALLBACK_LANGUAGE;

        vm.selectLanguage(defaultLanguage);
      });
    };

    const deregistrationCallback = $rootScope.$on('selectDefaultLanguage', selectDefaultLanguage);
    $rootScope.$on('$destroy', deregistrationCallback);
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/tos_header.js